import styled from 'styled-components';
export const UnorderedListWrapper = styled.ul.withConfig({
  componentId: "ds__sc-cwrf8y-0"
})(["flex:1;margin:0;padding:0;list-style:none;"]);